<template>
  <div>
    <div class="wizardGrid">
      <div class="wizardTitle">
        <h1 class="comfortaa">Website Wizard</h1>
        <div style="place-self:center">
          <span class="wizardExit" @click="exitWizard()"><i class="fa fa-times"></i></span>
        </div>
      </div>

      <template v-if="page === 1">
        <div class="wizardCardContainer cardMiddle">
          <div class="wizardCard">
            <div class="text">Let's walk through some quick questions to get your site started. You'll be able to change and customize this information later.</div>
          </div>
        </div>
      </template>
      <template v-if="page === 2">
        <div class="wizardCardContainer cardMiddle">
          <div class="wizardCard">
            <div class="text">What is your Business or Organization's Name?<br/><span style="font-size:16px;">(Enter a Website Title if this is a personal site)</span></div>
          </div>
          <div class="wizardInputCard">
            <input class="w3-input w3-border" placeholder="Alt Apparel (example)" v-model="wizardData.site_name" />
          </div>
        </div>
      </template>
      <template v-if="page === 3">
        <div class="wizardCardContainer cardMiddle">
          <div class="wizardCard">
            <div class="text">Describe your business.</div>
          </div>
          <div class="wizardInputCard">
            <textarea class="w3-input w3-border" placeholder="Producing high quality apparel for youth sports activities (example)" v-model="wizardData.site_title"></textarea>
          </div>
        </div>
      </template>
      <template v-if="page === 4">
        <div class="wizardCardContainer">
          <div class="wizardCard">
            <div class="text">Choose a Color or enter your own HEX code.</div>
          </div>
          <div class="wizardInputCard">
            <div v-for="(color, index) in colors" :key="index" class="colorContainer">
              <div class="colorBlock" :style="{backgroundColor: color}" @click="chooseColor(color)"></div>
            </div>
          </div>
          <div class="wizardInputCard">
            <input class="w3-input w3-border" placeholder="#212121" v-model="wizardData.colors.primary.main" @input="chooseColor(wizardData.colors.primary.main)" />
          </div>
        </div>
      </template>
      <template v-if="page === 5">
        <div class="wizardCardContainer">
          <div class="wizardCard">
            <div class="text">Select features for your site.</div>
          </div>
          <div class="wizardInputCard">
            <div v-for="(feature, index) in features" :key="index" class="featureContainer">
              <span>{{feature.title}}</span>
              <toggle :model="feature.model"></toggle>
            </div>
          </div>
        </div>
      </template>

      <div class="footerButtons">
        <template v-if="page !== 1">
          <div class="gridHalf">
            <div>
              <button class="btn btn-block btn-danger roboto" @click="pageNav('-')">Back</button>
            </div>
            <div>
              <button class="btn btn-block btn-success roboto" v-if="page !== 7" @click="pageNav('+')">Next</button>
              <button class="btn btn-block btn-success roboto" v-if="page === 7" @click="finish()">Finish</button>
            </div>
          </div>
        </template>
        <template v-if="page === 1">
          <button class="btn btn-block btn-success roboto" v-if="page !== 4" @click="pageNav('+')">Next</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default
import toggle from '@/system/atoms/toggle';

export default {
  name: 'siteWizard',
  data() {
    return {
      state: dataStore.state,
      wizardData: {
        colors: {
          primary: {
            main: ''
          }
        }
      },
      colors: ['#212121', '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#795548'],
      features: [
        {
          title: 'Gallery',
          model: 'siteData.content.photos.enabled'
        },
        {
          title: 'Shop',
          model: 'siteData.content.products.enabled'
        }
      ],
      page: 1
    }
  },
  components: {
    'toggle': toggle
  },
  methods: {
    pageNav(flow) {
      if (flow === '+') {
        this.page += 1
        this.$emit('changeBGColor', '#11202f')
      } else {
        this.page -= 1
      }
      console.log(this.page)
    },
    chooseColor(color) {
      if (color.length === 7) {
        this.wizardData.colors.primary.main = color
        this.$emit('changeBGColor', color)
      }
    },
    finish() {
      console.log('done')
    },
    exitWizard() {
      if (confirm('Are you sure you want to EXIT and abandon changes?')) {
        this.state.modals.wizard = false
      }
    }
  }
}
</script>

<style scoped>
  .wizardGrid {display:grid; grid-template-rows: auto 1fr auto; grid-template-areas: "title" "cards" "footer"; margin:0; height: 100vh;}
  .wizardExit {background-color:rgba(60, 0, 0, 0.3); padding: 8px 16px; border-radius:5px; color:#ddd; cursor: pointer;}

  .wizardTitle {color:#e0e0e0; grid-area: title; display:grid; grid-template-columns: 1fr 50px; padding:15px;}
  .wizardTitle h1 {font-size:24px;}
  .wizardCardContainer {padding:8px 15px; grid-area: cards; align-self: center; justify-self: center;}
  .wizardCard {margin-bottom:15px; padding:15px 15px 20px; width:100%; background:#fafafa; border-radius:5px; border:1px solid #ccc; min-width: 320px;}
  .wizardCard .text {font-size: 18px; font-family: 'Roboto Slab'; text-align: center; color:#212121;}

  .wizardInputCard {margin-bottom:15px; background:#fafafa; border-radius:5px; border:1px solid #ccc;}
  .wizardInputCard input {font-size: 18px; text-align: left; color:#212121;}
  /* .cardMiddle {position:absolute; top:50%; transform: translateY(-50%);} */
  
  .featureContainer {display:grid; grid-template-columns: 3fr 1fr; grid-gap: 8px; padding: 8px;}
  .featureContainer span {display:flex; align-items: center;}

  .colorContainer {display:inline-block; margin: 6px 4px 0;}
  .colorBlock {height:32px; width:32px;}

  .footerButtons {padding:0 15px 15px;}
  .footerButtons .btn {padding:10px 15px; font-size:18px;}

  .gridHalf {display:grid; grid-template-columns: 1fr 1fr; grid-gap: 8px;}

  @media screen and (max-width:600px) {
    .w3-xxxlarge {font-size:36px !important;}
  }
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsSiteWizard.vue